import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectBrokerConsultantBannerAvailable } from '../../selectors/brokerConsultantBanner';
import { isDiscountMortgageBannerEnabled } from '../../selectors/discountMortgage';
import { DiscountMortgageBannerContainer } from '../DiscountMortgageBannerContainer';
import { BrokerConsultantBannerContainer } from '../BrokerConsultantBannerContainer';

export const BannerContainer = () => {
  const isDiscountMortgageBannerAvailable = useSelector(isDiscountMortgageBannerEnabled);
  const isBrokerConsultantBannerAvailable = useSelector(selectBrokerConsultantBannerAvailable);

  if (isDiscountMortgageBannerAvailable) {
    return <DiscountMortgageBannerContainer />;
  }

  if (isBrokerConsultantBannerAvailable) {
    return <BrokerConsultantBannerContainer />;
  }

  return null;
};
